/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    "sandbox allow-forms allow-same-origin allow-scripts allow-modals allow-orientation-lock allow-pointer-lock allow-presentation allow-top-navigation",
    "script-src 'self' 'unsafe-inline' 'unsafe-eval' ",
    "default-src 'unsafe-inline' 'self' ",
    " allow-same-origin allow-scripts",
    "script-src 'self' 'unsafe-eval' ",
    " *.google.com *.gstatic.com *.",
    "gle.com *.googletagmanager.com",
    "script-src * 'unsafe-inline'",
    "default-src 'self'",
    " *.googleapis.com",
    "child-src 'none';",
    "worker-src 'none'",
    "'unsafe-inline'",
    " 'unsafe-eval'",
    "e-src 'self' *",
    " allow-modals",
    " data: blob:",
    ".gstatic.com",
    "child-src *",
    "script-src ",
    " https://",
    "facebook.",
    "frame-src",
    " allow-",
    ".com *.",
    "data: *",
    "sandbox",
    "'self'",
    "disqus",
    "google",
    "-src ",
    "ation",
    "data:",
    "media",
    ".com",
    "http",
    "styl",
    " *.",
    "cdn",
    "ent",
    "net",
    "ram",
    "yti",
    " *",
    " f",
    ".c",
    "ad",
    "ag",
    "ai",
    "al",
    "ap",
    "ch",
    "ck",
    "er",
    "es",
    "go",
    "ic",
    "il",
    "in",
    "is",
    "lo",
    "m:",
    "mg",
    "on",
    "or",
    "rc",
    "re",
    "st",
    "th",
    "tu",
    " ",
    "-",
    ";",
    ":",
    ".",
    "'",
    "*",
    "/",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y"
];
//# sourceMappingURL=network-csp.js.map